import React from "react";
import { Plus, Trash2 } from "lucide-react";
import AiPromptGenerator from "@/components/resume-builder/AiPromptGenerator";

const FIELD_CLASS = "bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-sm text-white placeholder:text-slate-400 focus:outline-none focus:ring-1 focus:ring-indigo-400";
const PROFICIENCY_LEVELS = ["Native", "Fluent", "Proficient", "Intermediate", "Basic"];
const EMPTY_ENTRY = { name: "", proficiency: "Proficient" };

export default function LanguagesSection({ draft, setDraft }) {
  const updateEntry = (idx, field, value) => setDraft({ ...draft, languages: draft.languages.map((e, i) => (i === idx ? { ...e, [field]: value } : e)) });
  const removeEntry = (idx) => setDraft({ ...draft, languages: draft.languages.filter((_, i) => i !== idx) });
  const addEntry = () => setDraft({ ...draft, languages: [...draft.languages, { ...EMPTY_ENTRY }] });

  return (
    <div className="glass-panel rounded-2xl p-5" data-testid="resume-section-languages">
      <div className="flex items-center justify-between mb-3">
        <p className="text-sm font-semibold text-white">Languages</p>
        <button onClick={addEntry} data-testid="resume-add-language-button" className="flex items-center gap-1 text-xs font-semibold text-indigo-300 hover:text-indigo-200">
          <Plus className="w-3.5 h-3.5" /> Add Language
        </button>
      </div>
      <div className="space-y-2">
        {draft.languages.map((entry, idx) => (
          <div key={idx} className="flex items-center gap-2" data-testid={`resume-language-entry-${idx}`}>
            <input value={entry.name} onChange={(e) => updateEntry(idx, "name", e.target.value)} placeholder="Language (e.g. English)" data-testid={`resume-language-name-${idx}`} className={FIELD_CLASS + " flex-1"} />
            <select value={entry.proficiency} onChange={(e) => updateEntry(idx, "proficiency", e.target.value)} data-testid={`resume-language-proficiency-${idx}`} className={FIELD_CLASS}>
              {PROFICIENCY_LEVELS.map((p) => <option key={p} value={p}>{p}</option>)}
            </select>
            <button onClick={() => removeEntry(idx)} data-testid={`resume-remove-language-${idx}`} className="text-slate-400 hover:text-red-400"><Trash2 className="w-3.5 h-3.5" /></button>
          </div>
        ))}
        {draft.languages.length === 0 && <p className="text-xs text-slate-400">No languages added yet.</p>}
      </div>
      <div className="mt-3">
        <AiPromptGenerator section="languages" draft={draft} setDraft={setDraft} />
      </div>
    </div>
  );
}
